import { Tooltip } from '@nextui-org/react';
import { useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Tag } from '../../../models/Listing';
import { BasicInfoBox } from '../VehicleCard';
import { InfoBoxTitle, InfoBoxValue, VehicleInfoBoxContainer } from '../VehicleCard.styles';
import { TagChip, TagsContainer } from './VehicleTagsBox.styles';

export interface TagsBox extends BasicInfoBox {
  tags: Tag[];
}

interface VehicleTagsBoxProps {
  data?: TagsBox;
  isCard?: boolean;
}

const VehicleTagsBox = ({ data, isCard }: VehicleTagsBoxProps) => {
  const { t } = useTranslation();
  const containerRef = useRef(null);
  const [shouldShowTooltip, setShowTooltip] = useState(false);

  useLayoutEffect(() => {
    if (isCard || !containerRef.current) return;
    const hasOverflowingChildren = containerRef.current.offsetWidth < containerRef.current.scrollWidth;
    setShowTooltip(hasOverflowingChildren);
  }, [isCard]);

  const renderTags = (isTooltip: boolean) => (
    <TagsContainer ref={containerRef} $isTooltip={isTooltip} $wrap={isCard}>
      {data?.tags.map((tag, index) => (
        <TagChip key={index}>{tag.name}</TagChip>
      ))}
    </TagsContainer>
  );

  const renderContent = () => (
    <VehicleInfoBoxContainer $minWidth={data.minWidth} $maxWidth={data.minWidth}>
      {data.title && <InfoBoxTitle>{data.title}</InfoBoxTitle>}
      {data?.tags.length > 0 ? renderTags(false) : <InfoBoxValue>{t('listings.emptyTags')}</InfoBoxValue>}
    </VehicleInfoBoxContainer>
  );

  return shouldShowTooltip ? (
    <Tooltip portalClassName="tooltip-wrapper" hideArrow content={<>{renderTags(true)}</>}>
      {renderContent()}
    </Tooltip>
  ) : (
    renderContent()
  );
};

export default VehicleTagsBox;
